import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import type {ShowModelPayload} from '../../types'

import {ModelLayout} from '../../components/models/ModelLayout'
import {SafeHTMLBox} from '@github-ui/safe-html'

export function License() {
  const {modelLicense} = useRoutePayload<ShowModelPayload>()

  return (
    <ModelLayout activeTab="license">
      <SafeHTMLBox className="p-3" html={modelLicense} />
    </ModelLayout>
  )
}

try{ License.displayName ||= 'License' } catch {}